import { render, staticRenderFns } from "./ProgramacionEdit.vue?vue&type=template&id=4285166f"
import script from "./ProgramacionEdit.vue?vue&type=script&lang=js"
export * from "./ProgramacionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports